<div class="md-checkbox">
    <input [id]="id" type="checkbox" [(ngModel)]="innerValue" (ngModelChange)="change($event)">
    <label [for]="id"></label>
</div>